module.exports = {
  "Gattaran_MSGCenter__CDEL": "Instruções para integração de mensagens",
  "Gattaran_Feedback__gRVu": "Até um anexo (não imagem) pode ser enviado",
  "Gattaran_V2_wZWG_RFvr": "Carregar grupo-alvo",
  "Gattaran_Homepage__SgjR": "Lista de permissões",
  "Gattaran_Homepage__nRqe": "Nenhum histórico de visitas",
  "Gattaran_Feedback__vYiO": "Selecione",
  "common_yes": "Sim",
  "Gattaran_MSGCenter__fKLA": "Selecione",
  "Gattaran_Feedback__bpPs": "Descrição do problema",
  "Gattaran_Feedback__QLll": "Módulo de recurso do Gattaran para ocorrência de problema",
  "Gattaran_V2_FXzs_ylzm": "Enviar para análise",
  "Gattaran_V2_aQes_enLD": "Descrição",
  "Gattaran_MSGCenter__JYjL": "Insira",
  "Gattaran_Feedback__TtBS": "Link da página de ocorrência do problema",
  "Gattaran_Feedback__zEDP": "Anexos de imagem (até 5 imagens de, no máximo, 5 MB cada)",
  "Gattaran_Feedback__AOcA": "Solicitante",
  "Gattaran_MSGCenter__rsFg": "Remover",
  "Gattaran_MSGCenter__jECw": "Enviar pela integração empresarial",
  "Gattaran_Feedback__auMY": "Ver",
  "Gattaran_MSGCenter__mzAm": "Notificações",
  "Gattaran_MSGCenter__esKt": "Insira a palavra-chave do título da mensagem",
  "Gattaran_system_KMzx_LdcE": "O feedback foi enviado para processamento ao backend do Lean. Você pode acompanhar o andamento neste link",
  "Gattaran_Homepage__Ntsj": "Para ajuda, entre em contato com: {{pm_name}}",
  "Gattaran_MSGCenter__YFIH": "ID",
  "Gattaran_Feedback__zikb": "Você pode conferir a lista “Meu Feedback” para ver o andamento do processamento do feedback",
  "FoodB_up250108_UBUH_aRBX": "Defina a contagem regressiva do pop-up",
  "Gattaran_Homepage__qJVu": "Os links para Minhas solicitações, Minhas funções e Minha auditoria agora estão aqui",
  "Gattaran_V2_tuhT_AOTp": "Enviar periodicamente",
  "Gattaran_V2_qdkl_zhnr": "Máximo",
  "Gattaran_V2_elkQ_uPKA": "vez(es)",
  "Gattaran_20240401_cZwR_udOc": "Detalhes da pesquisa",
  "Gattaran_V2_DECM_uvLB": "Nome do botão de link (exibição padrão: {{default}})",
  "sailing.dilu.myfeedback": "Meu Feedback",
  "Gattaran_V2_crhT_oxkz": "Sob análise",
  "Gattaran_Feedback__EAYk": "ID",
  "Gattaran_Homepage__IEfB": "“Visitados recentemente” mostra os recursos que você viu recentemente. É uma entrada de acesso rápido.",
  "soda-b-web-i18n---加载中": "Carregando...",
  "Gattaran_Homepage__HleZ": "As funções a seguir têm permissões para essa página:",
  "Gattaran_Feedback__MQam": "Nível de urgência",
  "Gattaran_MSGCenter__GFMl": "Destinatários planejados",
  "Gattaran_Homepage__TQJz": "A página atual não está integrada à nova versão do Gattaran. Para acessar essa página, clique no botão abaixo.",
  "Gattaran_Homepage__HCuT": "Barra de navegação principal",
  "Gattaran_MSGCenter__buje": "Criar",
  "Gattaran_V2_uXMx_qica": "Baixar modelo",
  "Gattaran_MSGCenter__Nbaz": "Data de início",
  "Gattaran_MSGCenter__yaaT": "Link da mensagem",
  "Gattaran_MSGCenter__SAQd": "Período de vigência",
  "Gattaran_Feedback__IdvX": "Anexo adicional (Excel, PDF, Word; apenas 1)",
  "Gattaran_Feedback__RCjf": "Criar novo feedback",
  "Gattaran_MSGCenter__jnGI": "Configurações do conteúdo",
  "Gattaran_Feedback_jzdw_zMgo": "Talvez eu tenha encontrado um erro técnico",
  "Gattaran_Feedback__dglB": "Descrição do problema",
  "Gattaran_Feedback_LxIv_wsSj": "Tenho uma solicitação/sugestão de recurso",
  "Gattaran_Feedback__eNEw": "Região de ocorrência do problema",
  "Gattaran_Feedback__Xbej": "Alto",
  "FoodOpD_tools_Original_file_QXqs": "Baixar arquivo original",
  "Gattaran_Feedback_aSQV_CWCu": "No que você precisa de ajuda?",
  "FoodD_one_Try_again_qZka": "Tentar novamente",
  "Gattaran_MSGCenter__ZPZZ": "Palavra-chave do título",
  "Gattaran_20240401_BAMn_cVoR": "As perguntas de múltipla escolha precisam conter pelo menos duas opções",
  "soda-t-i18n---确定": "Confirmar",
  "Gattaran_Feedback_yoej_DTPb": "Preciso de suporte da equipe técnica",
  "Gattaran_V2_OAkm_oSIp": "O módulo de produtos de nível final nas opções será mostrado como remetente de mensagem na Central de Mensagens Gattaran",
  "Gattaran_20240401_heKh_sVNg": "Obrigatório?",
  "Gattaran_MSGCenter__HjTW": "Enviar pelo backend da central de mensagens",
  "Gattaran_MSGCenter__PvCm": "Hora de envio",
  "Gattaran_Feedback__fRJi": "Médio",
  "Gattaran_Feedback__dOJj": "Baixo",
  "Gattaran_MSGCenter__MWqV": "Pesquisar",
  "Gattaran_MSGCenter__imft": "Apenas uma imagem pode ser enviada",
  "Gattaran_Feedback__JuAw": "A conclusão do processamento foi enviada com sucesso e o status do feedback mudou para “Concluído”",
  "Gattaran_Auth_dmRq_HvpZ": "Não é possível usar este recurso?",
  "Gattaran_Homepage__Hjbo": "Fale conosco",
  "Gattaran_Feedback_FAZM_REhE": "Quero aprender a usar esse recurso",
  "取消": "Cancel",
  "Gattaran_MSGCenter__qJkV": "Ativo",
  "Gattaran_20240401_Dqdw_zVjj": "Quer mesmo lançar essa pesquisa?",
  "Gattaran_V2_wQRP_UYwo": "Avaliador",
  "Gattaran_MSGCenter__iuwu": "Insira o ID",
  "Gattaran_20240401_ycgC_XryN": "Central de pesquisa",
  "Gattaran_Feedback__EhcV": "Informações do feedback",
  "FoodOpC_gattaran_Enter_CWSB": "Insira o texto aqui",
  "Gattaran_20240401_SptO_OiTm": "Limite de caracteres excedido",
  "Gattaran_20240401_dWRX_PBUn": "Tipo de pesquisa",
  "Gattaran_MSGCenter__kLtS": "Data de término",
  "Gattaran_Homepage__ybCE": "No Início, você encontra uma visão geral do sistema Gattaran",
  "Gattaran_Feedback_oHQm_chDu": "Entre no grupo D-Chat abaixo para compartilhar os detalhes e receber suporte da equipe de operações",
  "Gattaran_Feedback__lQre": "Solicitante",
  "Gattaran_MSGCenter__AjjW": "Enviar no horário especificado",
  "Gattaran_V2_ayrB_ekxC": "Imagem de capa (taxa de proporção: 3:1, largura sugerida: >800 px)",
  "Gattaran_MSGCenter__vrnW": "Ver detalhes",
  "Gattaran_Homepage__YscW": "Mais",
  "Gattaran_Homepage__ssGO": "Permissão ausente: {{node_info}}",
  "Gattaran_Feedback__HTsy": "Enviar",
  "Gattaran_Feedback__urHD": "Baixo",
  "Gattaran_MSGCenter__KgwQ": "Lançamento",
  "Gattaran_MSGCenter__UnwR": "Criar",
  "Gattaran_Homepage__DMWj": "Manual de integração de RD",
  "Gattaran_Feedback__cLbb": "Médio",
  "Gattaran_Feedback_NvwL_Uxho": "Preciso de suporte para outras operações",
  "Gattaran_V2_Tzot_kaOW": "Manual da Central de Mensagens (para PM/RD/PO)",
  "Gattaran_MSGCenter__pUdp": "Detalhes da mensagem",
  "Gattaran_V2_jXfh_Bzau": "Defina primeiro a “Seleção de fuso horário”",
  "Gattaran_Feedback_baMd_rUqS": "Solicitação de alteração de cardápio",
  "Gattaran_DataPortal__aqBh": "STAR (portal de dados)",
  "Gattaran_20240401_bAxu_VxZT": "Respondentes",
  "DiDi_Food_(C)_Customer_automatically_apply_Add_ZyML": "Adicionar",
  "Gattaran_MSGCenter__jcAm": "Selecione",
  "Gattaran_Feedback_UUdB_fdYt": "Tenho uma tarefa com análise pendente",
  "Gattaran_Feedback__qGnl": "Feedback enviado ao contato (PoC) de Produto, {{pm_name}}",
  "Gattaran_20240401_cSnz_WMLD": "Múltipla escolha",
  "Gattaran_20240401_iuEu_VEPo": "Pergunta de avaliação (escala de 10 pontos)",
  "Gattaran_alert_zVGm_gOUV": "Dados da nova versão disponíveis. Atualize para obter o conteúdo mais recente",
  "Gattaran_0411_MWuz_zfQj": "Localização do posicionamento",
  "Gattaran_MSGCenter__wEBm": "Nenhuma mensagem",
  "Gattaran_Homepage__XHuN": "Uma coleção de configurações de recursos básicos do Gattaran, como tarefas, análise, configuração de mensagem e feedback.",
  "Gattaran_Homepage__ktsW": "Confirmar",
  "Gattaran_Feedback__OHxt": "Feedback",
  "Gattaran_Homepage__vkPG": "Clique no link do grupo para participar",
  "Gattaran_Homepage__yTjZ": "Você não tem permissão para acessar essa página",
  "Gattaran_MSGCenter__tcGJ": "Forma de envio",
  "Gattaran_MSGCenter__tOPK": "Descrição da finalidade",
  "Gattaran_MSGCenter__mwuC": "Título da mensagem",
  "Gattaran_MSGCenter__jtwt": "Criado em",
  "FoodOpB_Gattaran_Edit_dTpu": "Editar",
  "Gattaran_V2_uLPb_Hgku": "Grupo personalizado",
  "Gattaran_V2_pLhS_NyGm": "Mensagens enviadas por meio da configuração de backend",
  "Gattaran_20240401_Dror_RtHt": "Tipo de pergunta",
  "soda-t-i18n---取消": "cancelar",
  "Gattaran_Feedback__LtzD": "Feedback",
  "Gattaran_20240401_mhox_xExM": "Insira a descrição de pergunta",
  "Gattaran_20240401_gZfx_mUCE": "Depois que essa pesquisa for lançada, ela será mostrada obrigatoriamente como um pop-up no aplicativo BD que não pode ser fechado. Quer mesmo lançar esta pesquisa?",
  "Gattaran_lowcode_dTZL_JDSp": "Uma nova janela foi aberta. Ela pode ser vista no navegador.",
  "Gattaran_Feedback__KBWX": "Hora da atualização de status",
  "soda-d-i18n---下载": "Baixar",
  "Gattaran_Feedback__HgXn": "Iniciar processamento",
  "Gattaran_Feedback__ZHEu": "Motivo do feedback",
  "Gattaran_Homepage__VxjE": "Barra de navegação",
  "Gattaran_MSGCenter__NWqi": "Ver",
  "Gattaran_20240401_EyCp_urep": "Selecionar um",
  "Gattaran_Feedback__yvfR": "Cancelar",
  "Gattaran_Feedback__amKQ": "Alto",
  "Gattaran_MSGCenter__xZzf": "Período de vigência",
  "Gattaran_Homepage__dzQv": "Ainda nenhuma permissão de função foi associada a esse recurso",
  "Gattaran_20240401_BIfp_ZYiB": "Pergunta de avaliação (escala de 5 pontos)",
  "Gattaran_20240401_gSOw_DugT": "{{research_num}} pesquisas foram adicionadas à página inicial do aplicativo BD nos últimos 30 dias. Um número grande de pesquisas pode interromper o trabalho diário dos BDs. Quer mesmo iniciar esta pesquisa?",
  "FoodB_up250108_fBFI_ZRnR": "Contagem regressiva do pop-up (atenção: isso impede que usuários fechem a janela por até 10s)",
  "Gattaran_lowcode_axmA_FvoV": "Não é possível obter o URL. Clique para tentar de novo ou entre em contato com o administrador da plataforma.",
  "Gattaran_Homepage__YLig": "Troca de link",
  "Gattaran_MSGCenter__PuUe": "Carregando…",
  "Gattaran_Feedback__EqVZ": "Nível de urgência",
  "Gattaran_Homepage__upog": "Bem-vindo ao Gattaran",
  "Gattaran_Homepage__kLUb": "Eu",
  "Gattaran_MSGCenter__Kbqd": "Definir um horário de envio especificado",
  "Gattaran_Feedback__dWQe": "Responsável pela tarefa",
  "Gattaran_MSGCenter__GxXJ": "Definir",
  "Gattaran_MSGCenter__cEqf": "Insira",
  "Gattaran_MSGCenter__BZkt": "Enviar registro",
  "Gattaran_MSGCenter__VINe": "Ver mais",
  "FoodB_system_AFma_LhIY": "Solicitar",
  "Gattaran_Homepage__GVcy": "Download de recursos de design",
  "Gattaran_Feedback__ddlX": "Feedback",
  "Gattaran_Homepage__FxHz": "Entendi",
  "Gattaran_Homepage__QaKY": "Fuso horário: {{cityname}}",
  "FoodOpB_management_Maximum_quantity_JEJp": "Quantidade máxima atingida",
  "Gattaran_MSGCenter__rffG": "Redefinir",
  "Gattaran_Homepage__XxTT": "Guia de uso do Gattaran",
  "Gattaran_Feedback__SwBm": "Ações",
  "Gattaran_Homepage__anfP": "Clique para ver uma lista de funções correspondentes a cada módulo de recurso.",
  "Gattaran_Feedback__chUi": "Insira uma descrição detalhada do problema, como quando ele ocorreu, o que fazer, o que aconteceu, com que frequência, etc.",
  "Gattaran_Feedback__cEaW": "Módulo",
  "Gattaran_Homepage__KEfd": "Clique nas opções na barra de navegação principal, como Estabelecimento, Entregador Parceiro ou Dados dos Produtos, para acessar os subsistemas correspondentes. O menu de navegação esquerdo no subsistema mostra todos os módulos de recursos do subsistema para os quais você tem permissões no momento. Cada subsistema oferece uma página de visão geral do recurso, em que você pode ver uma lista completa dos recursos do subsistema, obter uma lista de funções relacionadas e solicitar rapidamente permissões.",
  "FoodB_I_Exit_sfrY": "Sair",
  "Gattaran_Homepage__AHIW": "Manual de design do produto",
  "Gattaran_Feedback__SHVh": "Responsável pela tarefa",
  "Gattaran_Feedback_JvYQ_JyXO": "Gostaria de alterar as informações da loja/signatário",
  "Gattaran_V2_LuUu_Rpls": "Recusada",
  "Gattaran_MSGCenter__myYJ": "Baixar modelo",
  "sailing.dilu.SysBasicConfig": "Configurações do sistema",
  "Gattaran_MSGCenter__XIYn": "Configuração de mensagem",
  "Gattaran_Feedback__Govn": "Região de ocorrência do problema",
  "Gattaran_V2_NzFp_yjYY": "Ver detalhes",
  "Gattaran_MSGCenter__FtSp": "Adicionar",
  "soda-m-i18n---您当前的网络环境不太好，请更换至网络稳定的环境再次尝试": "Seu ambiente de rede atual não é muito bom. Tente mudar novamente para um ambiente de rede estável",
  "Gattaran_Feedback__fnhs": "Conclusão do processamento",
  "Gattaran_Homepage__OukI": "Versão antiga",
  "Gattaran_Feedback__ykZG": "Você pode enviar até 5 imagens",
  "FoodB_system_MBBl_SUqv": "Bug",
  "Gattaran_Homepage__SbiO": "Os produtos foram reclassificados de acordo com o tipo de empresa. Conheça o novo método de classificação e descubra mais recursos úteis.",
  "Gattaran_MSGCenter__kiOa": "Empresa",
  "Gattaran_Feedback_BnWd_kcBd": "Encontrei um erro no texto",
  "Gattaran_Feedback_Uxer_NPzU": "Não tenho acesso a esse recurso",
  "Gattaran_MSGCenter__esUP": "Parar esta mensagem?",
  "FoodB_202502_iDjM_HZOr": "Envie apenas uma vez",
  "Gattaran_0416_aBBV_Ymcw": "Caixa de entrada de várias linhas",
  "Gattaran_V2_KeYD_zlnO": "A hora de envio precisa ser igual ou posterior à hora de início do período de vigência do cartão de mensagem",
  "Gattaran_Feedback__mVws": "Carregar",
  "FoodOpC_Notifications_Time_zone_YaBE": "fuso horário",
  "Gattaran_MSGCenter__Xxgq": "Cancelar",
  "FoodOpB_copy_The_interval_zsXr": "O tempo entre os pedidos não pode exceder {{day}} dia(s)",
  "Gattaran_Homepage__Tchu": "Visitados recentemente",
  "Gattaran_MSGCenter__pLZR": "Diário",
  "Gattaran_Homepage__XQjL": "Solicitar permissões",
  "Gattaran_MSGCenter__xOWq": "Conteúdo da mensagem",
  "Gattaran_V2_yYKm_eBiS": "Cartão de mensagem da janela pop-up",
  "Gattaran_V2_lotK_apqj": "Até",
  "Gattaran_MSGCenter__HxEk": "Tudo",
  "Gattaran_MSGCenter__ehbg": "Seleção de fuso horário",
  "Gattaran_V2_omYw_wLSK": "Imagens de conteúdo (até 4 imagens)",
  "Gattaran_Homepage__PTEn": "Avançar",
  "Gattaran_MSGCenter__eNOL": "Insira",
  "FoodC_remind_Unable_to_Wjlz": "Não foi possível carregar. Toque para tentar novamente.",
  "Gattaran_MSGCenter__iWDe": "Configurações básicas",
  "Gattaran_MSGCenter__DUmv": "Enviar imediatamente",
  "Gattaran_Feedback__SPGu": "Status atual do processamento",
  "Gattaran_lowcode_dnHP_Gabp": "Não é possível carregar a página. Clique para tentar de novo ou entre em contato com o administrador da plataforma.",
  "Gattaran_Homepage__lnWD": "Voltar",
  "Gattaran_MSGCenter__yJJS": "Módulo do produto",
  "Gattaran_MSGCenter__bLAo": "Imagem (dimensões sugeridas: 624 x 312 px)",
  "Gattaran_Homepage__uCVu": "Ver guia",
  "Gattaran_Homepage__lXkk": "Definir país, fuso horário e idioma",
  "Gattaran_MSGCenter__vKEM": "Versão padrão",
  "Gattaran_MSGCenter__oHtl": "Marcar tudo como lido",
  "Gattaran_MSGCenter__lbqY": "Ações",
  "Gattaran_Homepage__bYLT": "Início",
  "FoodB_system_cYsu_ZWYN": "Consulta da ação",
  "Gattaran_MSGCenter__xBnV": "Emitido",
  "Gattaran_Homepage_soPn_KBFC": "Módulo comum e modelos de página",
  "Gattaran_MSGCenter__XgxF": "Grupo alvo",
  "FoodOpB_Authority2_Role_List_OQWs": "Lista de funções",
  "Gattaran_Feedback__ktgU": "O link da página é inválido",
  "Gattaran_Feedback__zzVL": "Link da página de ocorrência do problema",
  "Gattaran_Feedback__adec": "O processamento do feedback começou. O status do processamento mudou para “Processando”",
  "Gattaran_MSGCenter__wdfs": "Concluído",
  "FoodB_system_EWCs_iStS": "Tipo de ticket",
  "Gattaran_Feedback__xywA": "Insira",
  "Gattaran_20240401_SucJ_yXvM": "Opções da pergunta",
  "Gattaran_Homepage__qMzz": "ou escaneie o QR Code para entrar no “Grupo de feedback online do Gattaran” pelo D-Chat",
  "Gattaran_MSGCenter__ypXf": "Hora de envio",
  "Gattaran_MSGCenter__SGXp": "Remover esta mensagem?",
  "Gattaran_MSGCenter__sQlj": "Criado por",
  "Gattaran_MSGCenter__wYPN": "Aplicativo destinatário",
  "Gattaran_MSGCenter__CUTJ": "Personalizado {{version_num}}",
  "Gattaran_Feedback__pbpG": "Detalhes do feedback",
  "Gattaran_Feedback__BoaN": "Motivo do feedback",
  "Gattaran_V2_fiBJ_wAfB": "Período de vigência do cartão de mensagem",
  "Gattaran_MSGCenter__qflV": "Selecione",
  "Gattaran_Homepage__MtRG": "Ver permissões",
  "sailing.dilu.newfeedback": "Feedback",
  "Gattaran_0424_HooT_uHlF": "Cancelar",
  "Gattaran_MSGCenter__sRnc": "Selecione o horário de criação",
  "Gattaran_Homepage__aeIE": "Clique para ver",
  "soda-m-i18n---查询到的数据有点小问题，请再试一次": "Há um problema com os dados que você está consultando, tente novamente",
  "Gattaran_Homepage__KisY": "Para acessar esse recurso, solicite as permissões de função apropriadas com base no seu cargo.",
  "Gattaran_20240401_dTUg_cbfD": "Configuração de conteúdo da pesquisa",
  "Gattaran_20240401_EwyS_XNBx": "Título da pesquisa",
  "Gattaran_MSGCenter__WOKq": "Ver menos",
  "Gattaran_Homepage__rxJe": "Cancelar",
  "Gattaran_MSGCenter__fKVx": "Título da mensagem",
  "Gattaran_MSGCenter__jVqk": "Aplicativo destinatário",
  "Gattaran_V2_HsHn_NQQR": "Frequência de exibição do cartão de mensagem",
  "Gattaran_V2_ghDi_LLbp": "Grupo-alvo",
  "Gattaran_Feedback__UgYW": "Entendi",
  "FoodB_statistics_Refresh_qDDP": "Atualizar",
  "Gattaran_MSGCenter__TIzW": "Tipo de idioma",
  "Gattaran_MSGCenter__Krud": "Status",
  "Gattaran_MSGCenter__gzaW": "Selecione",
  "Gattaran_V2_kzRk_KWRP": "Todos os grupos",
  "FoodB_2_Created_successfully_IqRa": "Criado com sucesso!",
  "Gattaran_V2_Lyuv_BCOl": "Esse período é usado por outro cartão de mensagem",
  "Gattaran_MSGCenter__tgFp": "Módulo do produto",
  "Gattaran_0424_aMnh_OeRE": "Confirmar",
  "FoodC_sales_Not_set_AJmE": "Agora não",
  "Gattaran_20240401_vCtD_sEvO": "Criar nova pesquisa",
  "Gattaran_MSGCenter__chmB": "Não há mais mensagens",
  "Gattaran_Homepage__KYtj": "Idioma",
  "Gattaran_Homepage__lRUO": "País",
  "Gattaran_0416_eOIG_voOz": "Adicionar uma pergunta",
  "Gattaran_Homepage__AmGl": "Permissões existentes",
  "Gattaran_V2_XkEi_RPoU": "{{num}} vez(es) por dia",
  "Gattaran_Homepage__BYnh": "Sem permissão",
  "Gattaran_Homepage__Fkve": "A barra de navegação permite definir o país e o idioma, ver mensagens e notificações e nos enviar feedback",
  "Gattaran_Feedback__QMDO": "Andamento do processamento",
  "Gattaran_Auth_fSHw_fDtt": "Solicitar permissão agora",
  "Gattaran_Feedback__WUQR": "Meu Feedback",
  "Gattaran_Feedback__NySC": "Feedback enviado com sucesso",
  "common_no": "Não",
  "Gattaran_Feedback_hXFJ_wgsq": "Solicitação de gerenciamento de leads (suspender, reativar, criar, editar etc.)",
  "Gattaran_MSGCenter__jiXX": "Tipo de mensagem",
  "Gattaran_Homepage__pnNi": "Clique neste ícone para retornar ao Início, onde você pode acessar o recurso “Visitados recentemente”, ver uma visão geral do sistema Gattaran e solicitar permissões rapidamente.",
  "Gattaran_MSGCenter__SwjL": "Parar",
  "Gattaran_Auth_BQfS_LpZc": "Faça um comentário",
  "Gattaran_MSGCenter__hpmD": "Tipo de mensagem",
  "FoodOpB_entrance_Learning_Centre_ENzd": "Centro de treinamento",
  "FoodB_modification_Modified_sTAw": "Editado com sucesso",
  "FoodB_system_QnGW_PNFN": "Copywriting",
  "Gattaran_mgt_Tips_NpAN": "Lembretes",
  "Gattaran_Homepage__oGEC": "Visão geral",
  "Gattaran_Feedback__GGDd": "Enviar conclusão",
  "Gattaran_Feedback__EeVZ": "Conclusão do processamento",
  "FoodB_up250108_muEZ_uUVF": "Copiar",
  "Gattaran_20240401_hhVY_xurV": "Defina pelo menos uma pergunta",
  "Gattaran_Feedback__dGOG": "Cancelar",
  "Gattaran_20240401_FchZ_ipbt": "Configuração de informações básicas",
  "Gattaran_MSGCenter__uZZb": "Imagem",
  "Gattaran_lowcode_xOev_XItQ": "Não é possível obter o recurso de página. Clique para tentar de novo ou entre em contato com o administrador da plataforma.",
  "Gattaran_MSGCenter__RtfX": "Insira uma descrição para gerenciamento de modelo",
  "Gattaran_MSGCenter__oaHw": "Contagem de mensagens lidas",
  "Gattaran_0416_dvjl_GeNS": "Pergunta {{num}}",
  "Gattaran_notice_dpsU_cOCk": "Removido",
  "Gattaran_MSGCenter__WGno": "Selecione"
}